<template>
	
	<div class="flex flex-col c-box"  @click.stop>
		<div class="header-box">
			<p style="width: 90%; margin: 0 auto"  :title="preViewData.zpname" class="nowrap">
				{{ preViewData.zpname  }}
			</p>
			<div class="close-box" @click="closePreview">×</div>
		</div>
		<div class="centent-box">
			   	<div  class="review-content"  >
			          <!-- 评分指标：只读展示各指标得分与总分 -->
          <div class="item-score-wrap" v-if="izScoring && itemList.length > 0">
            <a-table
              class="table"
              :columns="itemColumns"
              :data-source="itemList"
              :pagination="false"
              row-key="id"
              bordered
              size="small">
            </a-table>
            <div class="target-score">
              总分：<span class="number">{{ totalScore }}</span><span class="score-unit" v-if="hasScore">分</span>
            </div>
          </div>
          <div class="score-wrap" v-if="izScoring && itemList.length === 0">
            <span class="score-label">得分：</span>
            <span class="score-value">{{ scoreText }}</span>
            <span class="score-unit" v-if="hasScore">分</span>
          </div>
			          <div class="expertReviews" v-if="izReview">
			            <div class="expertReviews-title">专家评语</div>
			            <a-textarea
			              class="remark-input"
			              v-model="reviewData.remark"
			              placeholder=""
			              :maxLength="500"
			               readonly="readonly"
			              :auto-size="{ minRows: 4, maxRows: 6 }"
			              :disabled="evaluationTablePreview"
			            />
			          </div>
			          <!--<div class="submit" @click="submit" v-if="!evaluationTablePreview">提交</div>-->
			        </div>
	  </div>
</div>
			
</template>

<script>
import { getAction, postAction  } from "@/api/index";
export default{
		props: {
			preViewData: {
				type: Object,
			},
			expertUserId:{
				type:String,
				default:'',
			},
	},
	mounted(){
		this.getStatus();
		this.getReviewTable();
	},
	data(){
		return {
			
			evaluationTablePreview:false,
		    reviewData: {
		        // 专家评语
		        remark: "",
		    },
		    // 评审
		    reviewShow: false,
		    emptyPrompt: false,
			  izReview:false,
			  izScoring:false,
			// 评分指标列表
			itemList: [],
			// 评分指标表格列
			itemColumns: [
				{
					title: '评价指标', key: 'indicator', width: '20%',
					customRender: (text, record) => record.oneTarget || record.twoTarget || ''
				},
				{ title: '指标内涵', dataIndex: 'content', key: 'content' },
				{ title: '分值', dataIndex: 'score', key: 'score', width: '80px', align: 'center' },
				{ title: '得分', dataIndex: 'itemScore', key: 'itemScore', width: '80px', align: 'center' },
			],
		}
	},
	computed: {
		// 是否已有得分
		hasScore() {
			return this.reviewData.score !== null && this.reviewData.score !== undefined && this.reviewData.score !== '-';
		},
		// 得分展示文案
		scoreText() {
			return this.hasScore ? this.reviewData.score : '未评分';
		},
		// 是否存在按指标录入的得分
		hasItemScore() {
			return this.itemList.some(item => typeof item.itemScore === 'number' && !isNaN(item.itemScore));
		},
		// 总分：优先按指标得分求和；历史数据（改动前只存总分）无指标得分时，回退为已保存的总分
		totalScore() {
			if (this.hasItemScore) {
				return this.itemList.reduce((sum, item) => {
					const v = Number(item.itemScore);
					return sum + (isNaN(v) ? 0 : v);
				}, 0);
			}
			const s = Number(this.reviewData.score);
			return isNaN(s) ? 0 : s;
		},
	},
	methods: {
		 getStatus(){
					getAction('/lx/lxApply/getReviewAndScore',{}).then((res) => {
						if (res.code === 200) {
						this.izScoring=res.result.izScoring==1?true:false;
						this.izReview=res.result.izReview==1?true:false;
						}else{
						this.$message.error(res.message);
						}
					});
		  },
		  getReviewTable() {
			      let params = {
			        applyType: 4,
			        applyId: this.preViewData.id,
			        expertUserId: this.expertUserId,
			      };
				  if(this.$route.name=='alApply'){
						params.applyType=4;
				  }else{
					params.applyType=1;
				  }
			      getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
			        if (res.code == 200) {
			          this.$set(this.reviewData, 'score', res.result.score);
          this.reviewData.remark = res.result.remark || "";
          // 只读回显评分指标及各指标得分
          let dataList = res.result.dataList || [];
          dataList.forEach((item) => {
            item.itemScore = (item.itemScore === null || item.itemScore === '' || item.itemScore === undefined)
              ? '-' : Number(item.itemScore);
          });
          this.itemList = dataList;
        }
			      });
			},
			closePreview() {
				this.$emit("closePreview");
			},
			
	}
}
</script>
<style scoped lang="scss">
     *{
     	font-size: 18px;
     }
	.img-box {
		width: 15px;
		height: 17px;
		margin-right: 8px;
	}
	
	.img-box-min {
		width: 10px;
		height: 12px;
		margin-right: 8px;
	}
	
	.c-box {
		width: 100%;
		height: 100%;
		background: url("../../assets/images/img19.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.c-box-fullscreen {
		width: 100%;
		height: 100%;
		background: #fff;
		/* background: url("../../assets/images/img19.png") no-repeat;
  background-size: 100% 100%;*/
	}
	
	.header-box-fullscreen {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.header-box {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		margin: 0px 19px 0px 9px;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.centent-box {
		margin: 0 12px 5px 0;
		padding: 10px 25px;
		height: 80%;
		overflow: auto;
		.box-item{
			margin:20px auto;
			/deep/ .ant-descriptions-item-label{
				width:120px;
			}
			/deep/ .ant-descriptions-item-content{
				width:240px;
			}
		}
    }
	.close-box {
		position: absolute;
		color: #fff;
		font-size: 40px;
		right: 3%;
		cursor: pointer;
		top: -2px;
	}
	
	 .review-content {
			      display: flex;
			      flex-direction: column;
			      justify-content: space-between;
			      height: 100%;
			      padding-bottom: 10px;
			      .table{
			      	 /deep/ .ant-table-thead > tr > th {
	                  font-size: 18px!important;
	                 }
			      	 /deep/ .ant-table-tbody > tr > td {
	                  font-size: 18px;
	                   padding: 15px!important;
	                 }
			      }
			     
	        }
			    .target-score {
			      margin-top: 10px;
			      color: #6c6c6c;
			      text-align: right;
			      .number {
			        font-size: 20px;
			        color: #9A0B00;
			      }
			      .score {
			        color: #9A0B00;
			      }
			    }
			    .score-wrap {
			      margin-top: 10px;
			      font-size: 18px;
			      color: #000;
			      .score-label {
			        font-weight: bold;
			      }
			      .score-value {
			        font-size: 20px;
			        color: #9A0B00;
			      }
			      .score-unit {
			        color: #9A0B00;
			      }
			    }
			    .expertReviews-title {
			      font-size: 18px;
			    }
			    .expertReviews-title:before {
			      display: inline-block;
			      width: 6px;
			      height: 22px;
			      background: #9A0B00;
			      border-radius: 5px;
			      content: "";
			      /**
			    这个指为正的话 小方块就往上， 为负的话，小方块就往下
			    */
			      vertical-align: middle;
			      margin-right: 6px;
			    }
			    .remark-input {
			      margin-top: 20px;
			      resize: none;
			    }
			    .submit {
			      width: 263px;
			      height: 41px;
			      background: #9A0B00;
			      border-radius: 8px;
			      line-height: 41px;
			      text-align: center;
			      margin: 0 auto;
			      color: #ffffff;
			      margin-top: 30px;
			      cursor: pointer;
			    }	
</style>